<template>
  <div class="inner-content">
    <div class="scroll-box">
      <div class="center" v-html="$lg(config, 'bonus_rules', '')"></div>
    </div>
  </div>
</template>
 
<script>
import { mapState } from 'vuex'

export default {
  name: 'Tab1Content1',
  inject: ['json_config'],
  computed: {
    ...mapState(['token']),
    config() {
      return this.json_config()
    },
  },
};
</script>

<style lang="scss" scoped>

.inner-content {
  width: 1066px;
  height: 565px;
  overflow: hidden;
  .scroll-box {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    white-space: pre-line;
    .center {
      height: 379px;
      margin: 30px 59px;
      font-size: 20px;
      font-weight: 500;
      color: #666;
      ::v-deep p {
        margin-top: 0;
        margin-bottom: 15px;
        display: flex;
        padding-left: 25px;
      }
      ::v-deep h3 {
        font-weight: normal;
        margin: 30px 0 15px;
        img {
          width: 21px;
          height: 21px;
          padding-top: 3px;
          margin-right: 4.5px;
        }
      }
    }
  }
}
  
</style>